module.exports = __webpack_public_path__ + "bb616c9ec60cde6806bbc1c62b4e2a6d.svg";